import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';
import { reassignDeactivatedUserToDifferentOrganization } from '@/services/api/requests/user';
import queryKeys from '@/constants/queryKeys';

const useReassignDeactivatedUserToDifferentOrganization = (onSuccess?: () => void) => {
  const toast = useToast();

  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: async ({ userId, organizationId }: { userId: string; organizationId: string }) => {
      await reassignDeactivatedUserToDifferentOrganization(userId, organizationId);

      queryClient.invalidateQueries({
        queryKey: [queryKeys.users.deactivatedUsers],
        exact: false,
        stale: true,
      });
    },
    onSuccess: () => {
      toast({
        title: 'User reassigned to different organization successfully',
        description: 'The user has been reassigned to a different organization.',
        status: 'success',
      });
      onSuccess?.();
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          title: 'Failed to reassign user',
          description: error?.errors[0]?.message,
          status: 'error',
        },
        error,
      );
    },
  });

  return { mutate, isPending };
};

export default useReassignDeactivatedUserToDifferentOrganization;
